var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeacherDesk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 88,
    viewBox: "0 0 81 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.37323 51.7786L1.94558 52.6429L22.2432 40.8729L20.6709 40.0086V6.34857L0.37323 18.1186V51.7786Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.94559 52.6429L22.2432 40.8729V7.21286L1.94559 18.9829V52.6429Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7568 86.8764L60.3291 87.7407L80.6268 75.9707L79.0544 75.1064V41.4464L58.7568 53.2164V86.8764Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6268 43.1986V40.37L0.37323 18.0479V19.9886L60.3291 54.0807L80.6268 42.3107",
    fill: "#DEDEDE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6268 43.1986V40.37L0.37323 18.0479V19.9886L60.3291 54.0807L80.6268 42.3107",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3291 87.7407L80.6268 75.9707V42.3107L60.3291 54.0807V87.7407Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6268 40.37L20.6709 6.27786L0.37323 18.0479L60.3291 52.1321L80.6268 40.37Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5126 35.4828L38.4988 29.6843L44.4229 26.0621L54.4288 31.8607L48.5126 35.4828Z",
    fill: "#979797",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.085 31.4286L48.9732 32.0964L43.9624 29.2207L45.9079 17.2857C45.8779 17.0186 45.9176 16.7483 46.0233 16.5007C46.1289 16.2531 46.297 16.0364 46.5115 15.8714C46.6759 15.7478 46.8767 15.6809 47.0832 15.6809C47.2898 15.6809 47.4906 15.7478 47.655 15.8714L51.0697 17.8279C51.3613 17.9962 51.6033 18.2371 51.7718 18.5265C51.9404 18.8159 52.0296 19.1439 52.0306 19.4779L50.085 31.4286Z",
    fill: "#979797",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9732 32.1121L43.9624 29.2364L45.9079 17.2857C45.9096 17.1493 45.947 17.0157 46.0166 16.898C46.0863 16.7803 46.1857 16.6826 46.305 16.6144C46.4244 16.5462 46.5597 16.51 46.6975 16.5092C46.8354 16.5084 46.971 16.5432 47.0912 16.61L50.1009 18.3386C50.3448 18.4852 50.5461 18.6918 50.6853 18.9382C50.8244 19.1847 50.8967 19.4627 50.895 19.745L48.9732 32.1121Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5588 31.24L37.2521 18.2286C37.218 18.2134 37.1901 18.1873 37.1728 18.1545C37.1556 18.1218 37.1499 18.0842 37.1568 18.0479L39.5947 0.762147C39.5947 0.495004 40.3888 0.180718 40.6827 0.345718L63.3785 12.9171C63.4946 12.9752 63.5893 13.0678 63.6492 13.1821C63.709 13.2963 63.731 13.4263 63.7121 13.5536L60.615 31.0121C60.5515 31.3814 59.9718 31.4286 59.5588 31.24Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5588 31.24L36.5691 18.48C36.5351 18.4648 36.5072 18.4387 36.4899 18.406C36.4726 18.3732 36.467 18.3356 36.4738 18.2993L39.5947 0.722866C39.6073 0.683501 39.6285 0.647352 39.6568 0.616959C39.6851 0.586566 39.7197 0.562666 39.7583 0.54694C39.7969 0.531214 39.8385 0.524043 39.8802 0.52593C39.9219 0.527818 39.9627 0.538718 39.9997 0.557866L62.7353 13.1607C62.8537 13.2182 62.9501 13.312 63.0102 13.4281C63.0703 13.5442 63.0909 13.6764 63.0688 13.805L60.0035 31.0907C59.9925 31.1358 59.9702 31.1774 59.9385 31.2116C59.9069 31.2458 59.8671 31.2715 59.8227 31.2864C59.7783 31.3013 59.7309 31.3049 59.6847 31.2968C59.6386 31.2887 59.5953 31.2691 59.5588 31.24V31.24Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7682 17.8043L59.0268 29.6057L61.7903 14.0014L40.5318 2.20001L37.7682 17.8043Z",
    fill: "#979797",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8785 34.2886L70.7956 30.8079L64.7523 34.2886L70.8353 37.7614L76.8785 34.2886Z",
    fill: "#979797",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4485 40.9514L70.8035 38.8693L67.1744 40.9514L70.8274 43.0336L74.4485 40.9514Z",
    fill: "#4A1E11"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7523 34.2886L67.1744 40.9514L70.8274 43.0336L70.8353 37.7614L64.7523 34.2886Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8785 34.2886L74.4485 40.9514L70.8273 43.0336L70.8353 37.7614L76.8785 34.2886Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8353 38.3743C70.7261 38.3733 70.6192 38.3435 70.5256 38.2879L64.4426 34.815C64.3487 34.7612 64.2706 34.6838 64.2164 34.5907C64.1622 34.4976 64.1336 34.3921 64.1336 34.2846C64.1336 34.1772 64.1622 34.0716 64.2164 33.9786C64.2706 33.8855 64.3487 33.8081 64.4426 33.7543L70.4859 30.2814C70.5815 30.2277 70.6896 30.1995 70.7996 30.1995C70.9095 30.1995 71.0176 30.2277 71.1132 30.2814L77.1803 33.7857C77.2754 33.84 77.3546 33.9178 77.4103 34.0114C77.466 34.1051 77.4962 34.2114 77.4979 34.32C77.4964 34.4267 77.4671 34.5312 77.4128 34.6234C77.3586 34.7156 77.2812 34.7924 77.1882 34.8464L71.145 38.3193C71.0482 38.3633 70.9416 38.3823 70.8353 38.3743V38.3743ZM65.9832 34.2807L70.8274 37.0543L75.6397 34.2886L70.7956 31.5229L65.9832 34.2807Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6471 27.2643C73.5115 26.7693 73.3447 28.9222 72.5426 29.2836C72.8682 27.6336 73.2732 27.0679 73.2732 25.6693C73.2732 23.3122 71.685 22.6914 70.7638 22.6914C69.8426 22.6914 68.2147 23.3279 68.2147 25.6693C68.2147 27.5236 68.7785 28.1364 69.1041 30.4936C68.175 30.0222 67.9685 27.5157 66.6185 28.0972C65.4274 28.6157 65.6418 31.13 69.2391 32.4579H69.2868C69.2868 33.0393 69.3344 33.6914 69.3344 34.4379C69.3344 34.8857 69.9618 35.2236 70.7479 35.2236C71.5341 35.2236 72.1615 34.8622 72.1615 34.4379C72.1615 32.9686 72.2171 31.8372 72.3044 30.9336C72.3568 30.944 72.4108 30.944 72.4632 30.9336C75.4888 29.8022 75.6635 27.6964 74.6471 27.2643Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0521 63.0222L39.9679 63.1557C39.9679 63.1557 41.5085 78.3122 41.5085 80.3629C41.5085 82.28 44.4388 83.8357 48.0521 83.8357C51.6653 83.8357 54.6035 82.2643 54.6035 80.3629C54.6035 78.3122 56.1362 63.1557 56.1362 63.1557L48.0521 63.0222Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0521 69.3079C51.7685 69.3079 54.8894 67.98 55.8344 66.165C55.9059 65.4343 55.9694 64.8136 56.025 64.3186C55.8763 63.8748 55.6294 63.4695 55.3024 63.1321L48.0521 63.0143L40.8018 63.1321C40.4752 63.4685 40.2307 63.8743 40.0871 64.3186C40.1347 64.8136 40.1982 65.4343 40.2697 66.165C41.2147 67.98 44.3356 69.3079 48.0521 69.3079Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0521 67.4379C52.5168 67.4379 56.1362 65.5207 56.1362 63.1557C56.1362 60.7907 52.5168 58.8736 48.0521 58.8736C43.5873 58.8736 39.9679 60.7907 39.9679 63.1557C39.9679 65.5207 43.5873 67.4379 48.0521 67.4379Z",
    fill: "#979797",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0521 60.7593C51.9035 60.7593 55.1197 62.1893 55.9376 64.0986C56.0656 63.8002 56.133 63.4798 56.1362 63.1557C56.1362 60.7986 52.5229 58.8657 48.0521 58.8657C43.5812 58.8657 39.9679 60.7829 39.9679 63.1557C39.9738 63.4803 40.0439 63.8007 40.1744 64.0986C40.9844 62.1893 44.2006 60.7593 48.0521 60.7593Z",
    fill: "#979797",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M40.095 22.7228L30.0574 28.545L23.22 24.6557L33.2576 18.8336L40.095 22.7228Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8044 22.2514L21.7747 28.0736L14.9294 24.1843L24.9671 18.3622L31.8044 22.2514Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4197 13.8207L15.3821 19.6429L8.53676 15.7536L18.5744 9.93143L25.4197 13.8207Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacherDesk);
export default __webpack_public_path__ + "static/media/TeacherDesk.57db871a0e9ff934120b184dcd3fafe0.svg";
export { ForwardRef as ReactComponent };